export default {
    apiKey: "AIzaSyDLG8IukJBnlZf2ahAtjTiaQ-PCgsXsPP8",
    authDomain: "enotice-production.firebaseapp.com",
    databaseURL: "https://enotice-production.firebaseio.com",
    projectId: "enotice-production",
    storageBucket: "enotice-production.appspot.com",
    messagingSenderId: "753063764402",
    appId: "1:753063764402:web:e5691c4ccbd76731"
  };